import styled from '@emotion/styled';

import { colorConstants } from 'config/colorConstants';

import {
    TABLE_SEGMENT_COLUMN_WIDTH_PX,
} from './packArchitectureTable.helpers';

export const VIRTUAL_TABLE_HEADER_HEIGHT_PX = 46;

export const VirtualizedTableShell = styled.div<{ $rowHeight: number }>`
    background: ${colorConstants.white};
    border-top: 0;

    .pack-arch-vtable-header-left.ant-table-header,
    .pack-arch-vtable-header-scroll.ant-table-header {
        border-bottom: 1px solid ${colorConstants.greyAlt2};
        background: ${colorConstants.greyAlt9};
        overflow: hidden !important;
    }

    .ReactVirtualized__Grid {
        outline: none;
    }

    .pack-arch-vtable-grid.ant-table-body {
        overflow: auto !important;
    }

    .pack-arch-vtable-left {
        overflow: hidden !important;
        border-right: 1px solid ${colorConstants.borderGrey};
        box-shadow: 8px 0 8px -8px ${colorConstants.packArchitectureFrozenColumnShadow};
    }

    .pack-arch-vtable-header-left.ant-table-header {
        border-right: 1px solid ${colorConstants.borderGrey};
        box-shadow: 8px 0 8px -8px ${colorConstants.packArchitectureFrozenColumnShadow};
    }

    .pack-arch-vtable-header-cell {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        height: ${VIRTUAL_TABLE_HEADER_HEIGHT_PX}px;
        padding: 0 16px;
        font-weight: 600;
        font-size: 12px;
        color: ${colorConstants.blackTransparent88};
        border-right: 1px solid ${colorConstants.greyAlt2};
        border-bottom: 1px solid ${colorConstants.greyAlt2};
        border-inline-end: 1px solid ${colorConstants.greyAlt2};
        background: ${colorConstants.greyAlt9};
        white-space: nowrap;
        text-align: left;
        line-height: 18px;
        cursor: pointer;
        box-sizing: border-box;
    }

    .pack-arch-vtable-header-cell.segment {
        z-index: 3;
        width: ${TABLE_SEGMENT_COLUMN_WIDTH_PX}px;
        min-width: ${TABLE_SEGMENT_COLUMN_WIDTH_PX}px;
        max-width: ${TABLE_SEGMENT_COLUMN_WIDTH_PX}px;
        border-right: 1px solid ${colorConstants.borderGrey};
        border-inline-end: 1px solid ${colorConstants.borderGrey};
    }

    .pack-arch-vtable-header-cell.vendor {
        min-width: 0;
    }

    .pack-arch-vtable-header-cell.table-header-hover-column {
        background: ${colorConstants.tableHeaderHoverBg} !important;
        border-bottom: 1px solid ${colorConstants.tableColorSplit} !important;
    }

    .pack-arch-vtable-cell {
        display: flex;
        align-items: stretch;
        justify-content: flex-start;
        height: ${({ $rowHeight }) => $rowHeight}px;
        font-size: 12px;
        padding: 0;
        border-right: 1px solid ${colorConstants.greyAlt2};
        border-bottom: 1px solid ${colorConstants.greyAlt2};
        border-inline-end: 1px solid ${colorConstants.greyAlt2};
        background: ${colorConstants.white};
        box-sizing: border-box;
    }

    .pack-arch-vtable-cell.segment {
        z-index: 2;
        width: ${TABLE_SEGMENT_COLUMN_WIDTH_PX}px;
        min-width: ${TABLE_SEGMENT_COLUMN_WIDTH_PX}px;
        max-width: ${TABLE_SEGMENT_COLUMN_WIDTH_PX}px;
        padding: 0 16px;
        align-items: center;
        background: ${colorConstants.greyAlt9} !important;
        border-right: 1px solid ${colorConstants.borderGrey} !important;
        border-inline-end: 1px solid ${colorConstants.borderGrey} !important;
        font-weight: 600;
        color: ${colorConstants.blackTransparent88};
        line-height: 18px;
    }

    .pack-arch-vtable-cell.table-row-clickable.segment {
        cursor: pointer;
    }

    .pack-arch-vtable-cell.vendor-cell,
    .pack-arch-vtable-cell.vendor-cell-empty {
        min-width: 0;
        padding: 0;
        cursor: pointer;
        text-align: left;
    }

    .pack-arch-vtable-cell.table-row-dimmed,
    .pack-arch-vtable-cell.segment-cell-dimmed,
    .pack-arch-vtable-cell.vendor-cell-dimmed {
        opacity: 0.45;
    }

    .pack-arch-vtable-cell.table-row-selected {
        background: ${colorConstants.radioLabelPressedBg} !important;
        border-bottom: 1px solid ${colorConstants.greyAlt6} !important;
    }

    .pack-arch-vtable-cell.segment.table-row-selected {
        background: ${colorConstants.tableHeaderBg} !important;
    }

    .pack-arch-vtable-cell.segment-cell-selected {
        background: ${colorConstants.tableHeaderBg} !important;
        font-weight: 600;
    }

    .pack-arch-vtable-cell.vendor-cell-row-selected {
        background: ${colorConstants.radioLabelPressedBg} !important;
        border-bottom: 1px solid ${colorConstants.greyAlt6} !important;
    }

    .pack-arch-vtable-cell.vendor-cell-selected {
        border: 1px solid ${colorConstants.violetAlt1} !important;
        background: ${colorConstants.grey} !important;
        position: relative;
        z-index: 1;
    }

    .pack-arch-vtable-cell.table-row-selected.vendor-cell-selected,
    .pack-arch-vtable-cell.table-cell-hover-row.vendor-cell-selected,
    .pack-arch-vtable-cell.table-cell-hover-column.vendor-cell-selected,
    .pack-arch-vtable-cell.table-cell-hover-active.vendor-cell-selected {
        background: ${colorConstants.grey} !important;
        mix-blend-mode: normal;
    }

    .pack-arch-vtable-cell.table-cell-hover-row {
        background: ${colorConstants.tableHoverCrossFill} !important;
    }

    .pack-arch-vtable-cell.segment.table-cell-hover-row {
        background: ${colorConstants.tableRowAxisHoverFill} !important;
        border-bottom: 1px solid ${colorConstants.tableColorSplit} !important;
    }

    .pack-arch-vtable-cell.table-cell-hover-column {
        background: ${colorConstants.tableHoverCrossFill} !important;
        border-bottom: 1px solid ${colorConstants.greyAlt6} !important;
        mix-blend-mode: multiply;
    }

    .pack-arch-vtable-cell.table-cell-hover-active {
        background: ${colorConstants.tabBackground} !important;
        border-bottom: 1px solid ${colorConstants.greyAlt} !important;
        mix-blend-mode: normal;
    }
`;
